export const SolidButton = ({ label, onClick, buttonClass = "" }) => {
	return (
		<button
			onClick={onClick}
			className={buttonClass + " noto-sans-tc-medium bg-[#292929] text-white"}
		>
			{label}
		</button>
	);
};

export default SolidButton;
